module.exports = __webpack_public_path__ + "img/hamburger-alt.aebde13f.svg";